<template>
  <div class="ud-body">
    <a-card :bordered="false">
      <!-- 搜索表单 -->
      <a-form
        ref="form"
        name="aForm"
        :model="where"
        :label-col="{ md: { span: 6 }, sm: { span: 24 } }"
        :wrapper-col="{ md: { span: 18 }, sm: { span: 24 } }"
      >
        <a-row>
          <a-col :lg="20" :md="24" :sm="24" :xs="24">
            <a-form-item label="搜索字段:" :labelCol="{ span: 1.5, offset: 0 }">
              <a-select
                mode="multiple"
                v-model:value="addField"
                @change="fieldChange"
                placeholder="请选择搜索字段"
                allow-clear
              >
                <a-select-option
                  v-for="(item, index) in fieldList"
                  :key="index"
                  :value="index"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="4" :md="12" :sm="24" :xs="24">
            <a-form-item class="ud-text-right" :wrapper-col="{ span: 24 }">
              <a-space>
                <a-button type="primary" @click="reload">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col
            :lg="6"
            :md="12"
            :sm="24"
            :xs="24"
            v-for="item in customField"
            :key="item.fieldId"
          >
            <a-form-item :label="item.label">
              <a-input
                v-if="item.type === 'text'"
                v-model:value.trim="where[item.fieldId]"
                placeholder="请输入"
                allow-clear
              />
              <a-select
                v-if="item.type === 'select'"
                v-model:value="where[item.fieldId]"
                placeholder="请选择"
                allow-clear
              >
                <a-select-option
                  v-for="(value, index) in strToArr(item)"
                  :key="index"
                  :value="value"
                  >{{ value }}</a-select-option
                >
              </a-select>
              <a-select
                mode="multiple"
                v-if="item.type === 'selectMultiple'"
                v-model:value="where[item.fieldId]"
                placeholder="请选择"
                allow-clear
              >
                <a-select-option
                  v-for="(value, index) in strToArr(item)"
                  :key="index"
                  :value="value"
                  >{{ value }}</a-select-option
                >
              </a-select>
              <a-radio-group
                v-if="item.type === 'radio'"
                v-model:value="where[item.fieldId]"
              >
                <a-row>
                  <a-col
                    :span="12"
                    v-for="(value, index) in strToArr(item)"
                    :key="index"
                  >
                    <a-radio :value="value">{{ value }}</a-radio>
                  </a-col>
                </a-row>
              </a-radio-group>
              <a-checkbox-group
                v-if="item.type === 'checkbox'"
                v-model:value="where[item.fieldId]"
              >
                <a-row>
                  <a-col
                    :span="12"
                    v-for="(value, index) in strToArr(item)"
                    :key="index"
                  >
                    <a-checkbox :value="value">{{ value }}</a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
              <a-input-number
                v-if="item.type === 'number'"
                v-model:value="where[item.fieldId]"
                placeholder="请输入"
                allow-clear
              ></a-input-number>
              <a-textarea
                v-if="item.type === 'textarea'"
                allow-clear
                v-model:value="where[item.fieldId]"
                placeholder="请输入"
              ></a-textarea>
              <a-date-picker
                v-if="item.type === 'date'"
                v-model:value="where[item.fieldId]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <!-- 表格 -->
      <ud-pro-table
        ref="tableMember"
        row-key="id"
        :datasource="datasource"
        :columns="columns"
        :where="where"
        v-model:selection="selection"
        :scroll="{ x: 'max-content' }"
      >
        <template #nickname="{ record }">
          <router-link :to="'/system/user/info?id=' + record.userId">
            {{ record.nickname }}
          </router-link>
        </template>
        <template #roles="{ record }">
          <a-tag
            v-for="(item, index) in record.roles"
            :key="index"
            color="blue"
          >
            {{ item.roleName }}
          </a-tag>
        </template>
        <template #enable="{ text, record }">
          <a-switch
            :checked="text === 0"
            @change="(checked) => editEnabled(checked, record)"
          />
        </template>
        <!-- <template #action="{ record }">
          <a-space>
            <a @click="openEdit(record)">修改</a>
            <a-divider type="vertical" />
            <a-popconfirm
              title="确定要删除此用户吗？"
              @confirm="remove(record)"
            >
              <a class="ud-text-danger">删除</a>
            </a-popconfirm>
          </a-space>
        </template> -->
      </ud-pro-table>
    </a-card>
  </div>
  <!-- 编辑弹窗 -->
  <!-- <user-edit
    v-model:visible="showEdit"
    :corpId="corpId"
    :data="current"
    @done="importDone"
  /> -->
  <!-- 导入弹窗 -->
  <!-- <user-import v-model:visible="showImport" :corpId="corpId" @done="reload" /> -->
  <!-- 导出弹窗 -->
  <!-- <user-export v-model:visible="showExport" :corpId="corpId" @done="reload" /> -->
  <!-- 模板字段设置 -->
  <!-- <a-modal
    :width="1300"
    v-model:visible="showFieldList"
    :confirm-loading="loading"
    :footer="null"
  >
    <fromFieldList :formId="formId" @done='importDone'/>
  </a-modal> -->
</template>
<script>
import * as corpUserApi from '@/api/corp/corpUser.js'
// import fromFieldList from './field.vue'
import { createVNode } from 'vue'
import {
  // PlusOutlined,
  // MinusCircleOutlined,
  // ExportOutlined,
  // DeleteOutlined,
  // UploadOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons-vue'
// import UserEdit from './index-edit'
// import UserImport from './index-import'
// import UserExport from './index-export'
export default {
  name: 'CorpUser',
  props: {
    // 是否打开弹窗
    corpId: Number
  },
  components: {
    // PlusOutlined,
    // DeleteOutlined,
    // UploadOutlined,
    // ExportOutlined,
    // UserImport,
    // UserExport,
    // UserEdit,
    // fromFieldList
  },
  data() {
    return {
      // 表格列配置
      columns: [
        {
          key: 'index',
          width: 48,
          customRender: ({ index }) => this.$refs.tableMember.tableIndex + index
        },
        {
          title: '姓名',
          dataIndex: 'nickname',
          sorter: true
        },
        {
          title: '性别',
          dataIndex: 'sex',
          sorter: true
        },
        {
          title: '手机号',
          dataIndex: 'username',
          sorter: true
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          sorter: true
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'center',
          slots: { customRender: 'action' }
        }
      ],
      // 表格搜索条件
      where: {},
      // 表格选中数据
      selection: [],
      // 当前编辑数据
      current: null,
      // 是否显示编辑弹窗
      showEdit: false,
      // 是否显示用户导入弹窗
      showImport: false,
      // 是否显示导出字段
      showExport: false,
      formColums: [],
      fieldList: [], // 表单字段列表下拉框选择
      customField: [
        {
          fieldId: 'frmA',
          label: '序号',
          type: 'text'
        }
      ],
      formId: 0,
      showFieldList: false, // 设置字段显示隐藏
      addField: []
    }
  },
  watch: {
    corpId() {
      if (this.corpId) {
        this.queryFormField()
        this.reload()
      }
    }
  },
  mounted() {
    this.queryFormField()
  },
  methods: {
    strToArr(item) {
      const str = item.listData
      if (str) {
        const arr = str.split(',')
        return arr
      } else {
        return []
      }
    },
    openFieldList() {
      this.showFieldList = true
      this.formId = 'corp-' + this.corpId
      console.log('formId', this.formId)
    },
    // 选中字段改变
    fieldChange(e) {
      this.customField = []
      e.forEach((index) => {
        console.log('his.customField', 11)
        this.customField.push(this.fieldList[index])
      })
    },
    datasource(option, callback) {
      corpUserApi
        .page({
          corpId: this.corpId,
          ...this.where,
          page: option.page,
          limit: option.limit
        })
        .then((res) => {
          if (res.code === 0) {
            callback(res.data, res.count)
          } else {
            callback(res.msg)
          }
        })
        .catch((e) => {
          callback(e.message)
        })
    },
    /* 搜索 */
    reload() {
      this.selection = []
      this.$refs.tableMember.reload({ page: 1, where: this.where })
    },
    /*  重置搜索 */
    reset() {
      this.where = {}
      this.fieldId = ''
      this.fieldValue = ''
      this.reload()
    },
    /* 删除单个 */
    remove(row) {
      const hide = this.$message.loading('请求中..', 0)
      this.$http
        .delete('/frm/corpUser/' + row.id)
        .then((res) => {
          hide()
          if (res.data.code === 0) {
            this.$message.success(res.data.msg)
            this.reload()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((e) => {
          hide()
          this.$message.error(e.message)
        })
    },
    /* 批量删除 */
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请至少选择一条数据')
        return
      }
      this.$confirm({
        title: '提示',
        content: '确定要删除选中的用户吗?',
        icon: createVNode(ExclamationCircleOutlined),
        maskClosable: true,
        onOk: () => {
          const hide = this.$message.loading('请求中..', 0)
          this.$http
            .delete('/frm/corpUser/batch', {
              data: this.selection.map((d) => d.id)
            })
            .then((res) => {
              hide()
              if (res.data.code === 0) {
                this.$message.success(res.data.msg)
                this.reload()
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((e) => {
              hide()
              this.$message.error(e.message)
            })
        }
      })
    },
    /* 打开编辑弹窗 */
    openEdit(row) {
      this.current = row || { corpId: this.corpId }
      this.showEdit = true
    },
    // 查询
    resetColums() {
      this.columns = this.formColums.concat([
        {
          title: '操作',
          width: 200,
          align: 'center',
          slots: { customRender: 'action' }
        }
      ])
      this.reload()
    },

    // 查询字段列表
    queryFieldList(arr) {
      this.fieldList = arr.map((item) => {
        return {
          label: item.label,
          fieldId: item.fieldId,
          type: item.type,
          listData: item.listData
        }
      })
    },
    // 重置列表
    queryFormField() {
      const that = this
      corpUserApi
        .fieldList({ formId: 'corp-' + this.corpId, enable: true })
        .then((res) => {
          if (res.code === 0) {
            that.formColums = [
              {
                key: 'index',
                width: 48,
                customRender: ({ index }) =>
                  this.$refs.tableMember.tableIndex + index
              },
              {
                title: '状态',
                dataIndex: 'state',
                sorter: true
              }
            ]
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].type === 'image') {
                that.formColums.push({
                  title: res.data[i].label,
                  dataIndex: res.data[i].fieldId,
                  slots: { customRender: 'img' }
                })
              } else {
                that.formColums.push({
                  title: res.data[i].label,
                  dataIndex: res.data[i].fieldId,
                  sorter: true
                })
              }
            }
            this.queryFieldList(res.data)
            that.resetColums()
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    importDone() {
      this.queryFormField()
      this.reload()
    }
  }
}
</script>

<style scoped>
</style>
